import { Link } from 'react-router-dom';
import './index.css';
import mockup from './pictures/mockup.png';
import app_store from './pictures/app_store.svg';

function About() {
  return (
    <div className="app content-page">
      <div className="about-content">
        {/* Left side - text content */}
        <div className="about-text">
          <div className="title-section" style={{ alignItems: 'flex-start' }}>
            <h1>Total Ten</h1>
          </div>

          <div style={{ fontSize: '14px', lineHeight: 1.8, textAlign: 'left' }}>
            <p>
              Total Ten is a number puzzle game. Select 
              cells in rectangular groups that sum to 10 to clear them from the board.
            </p>

            <p style={{ marginTop: '1.5rem' }}>
              The game ends when you clear the entire board or when no more 
              valid moves remain.
            </p>

            <p style={{ marginTop: '1.5rem', opacity: 0.6 }}>
              © 2026 <a target="_blank" rel="noreferrer" href="https://zawie.io"> Adam Zawierucha</a>. All rights reserved.
            </p>

            <span className="button-container" style={{ justifyContent: 'flex-start', paddingLeft: 0, alignItems: 'center', gap: '12px' }}>
              <Link to="/">
                <button className="play-again-btn">Play Now</button>
              </Link>
              <a href="https://apps.apple.com/us/app/total-ten-game/id6757262537" style={{ display: 'flex' }}>
                <img src={app_store} height={40} alt="Download on App Store" />
              </a>
            </span>
          </div>
        </div>

        {/* Right side - iPhone mockup */}
        <div className="about-mockup">
          <img 
            src={mockup}
            alt="iPhone Mockup" 
            style={{ 
              maxHeight: "500px",
              objectFit: 'contain' 
            }} 
          />
        </div>
      </div>
    </div>
  );
}

export default About;